import { h } from 'preact'
import classNames from 'clsx'

import styles from './index.module.scss'

const MonthLink = ({ children, className, ...props }) => (
  <span
    className={classNames(className, styles['a-month-link'])}
    {...props}
  >
    {children}
  </span>
)

export default MonthLink
